export default "__VITE_ASSET__4a68abd1__"